
import { useTranslation } from "react-i18next";

export default function InstructorSection() {
  const { t } = useTranslation();

  return (
    <section id="instructor" className="py-24 bg-gradient-to-br from-teal-50 via-white to-orange-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl sm:text-5xl font-bold text-center text-gray-900 mb-16">
          {t("instructor_title")}
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="w-full h-[600px] rounded-2xl overflow-hidden shadow-2xl">
            <img 
              src="https://static.readdy.ai/image/2ea0b8c267a34173059ce081fb680942/aa6beeabb90d299a3c1c89fcb1a67571.jpeg"
              alt="Mari Haruno - Instructor"
              className="w-full h-full object-cover object-top"
            />
          </div>

          {/* Profile Details */}
          <div className="lg:col-span-2 space-y-8">
            {/* Name */}
            <div className="bg-gradient-to-r from-teal-100 to-orange-100 rounded-xl p-6">
              <h3 className="text-2xl font-bold text-gray-900 flex items-center">
                <i className="ri-user-line text-teal-600 mr-3"></i>
                {t("instructor_name")}
              </h3>
            </div>

            {/* Education */}
            <div>
              <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                <i className="ri-graduation-cap-line text-teal-600 mr-2"></i>
                {t("instructor_education_title")}
              </h4>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-600 mr-2 mt-1 flex-shrink-0"></i>
                  <span className="text-justify">{t("instructor_education1")}</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-600 mr-2 mt-1 flex-shrink-0"></i>
                  <span className="text-justify">{t("instructor_education2")}</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-teal-600 mr-2 mt-1 flex-shrink-0"></i>
                  <span className="text-justify">{t("instructor_education3")}</span>
                </li>
              </ul>
            </div>

            {/* Career */}
            <div>
              <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                <i className="ri-briefcase-line text-teal-600 mr-2"></i>
                {t("instructor_career_title")}
              </h4>
              <ul className="space-y-3 text-gray-700">
                <li className="text-justify leading-relaxed">{t("instructor_career1")}</li>
                <li className="text-justify leading-relaxed">{t("instructor_career2")}</li>
                <li className="text-justify leading-relaxed">{t("instructor_career3")}</li>
                <li className="text-justify leading-relaxed">{t("instructor_career4")}</li>
              </ul>
            </div>

            {/* Personal Info */}
            <div className="bg-gradient-to-br from-teal-50 to-orange-50 rounded-xl p-6">
              <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                <i className="ri-heart-line text-teal-600 mr-2"></i>
                {t("instructor_personal_title")}
              </h4>
              <ul className="space-y-2 text-gray-700">
                <li className="text-justify leading-relaxed">{t("instructor_favorite_food")}</li>
                <li className="text-justify leading-relaxed">{t("instructor_favorite_color")}</li>
                <li className="text-justify leading-relaxed">{t("instructor_favorite_phrase")}</li>
                <li className="text-justify leading-relaxed">{t("instructor_personality")}</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Episodes */}
        <div className="bg-gradient-to-br from-orange-50 to-pink-50 p-8 sm:p-12">
          <h4 className="text-2xl font-bold text-gray-900 mb-6 text-center">
            {t("instructor_episodes_title")}
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white rounded-xl p-6 shadow-md">
              <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center mb-4">
                <span className="text-orange-600 font-bold">1</span>
              </div>
              <p className="text-gray-700 leading-relaxed text-justify">{t("instructor_episode1")}</p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md">
              <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center mb-4">
                <span className="text-orange-600 font-bold">2</span>
              </div>
              <p className="text-gray-700 leading-relaxed text-justify">{t("instructor_episode2")}</p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md">
              <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center mb-4">
                <span className="text-orange-600 font-bold">3</span>
              </div>
              <p className="text-gray-700 leading-relaxed text-justify">{t("instructor_episode3")}</p>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-md">
              <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center mb-4">
                <span className="text-orange-600 font-bold">4</span>
              </div>
              <p className="text-gray-700 leading-relaxed text-justify">{t("instructor_episode4")}</p>
            </div>
          </div>
        </div>

        {/* Dream */}
        <div className="bg-gradient-to-br from-teal-100 to-teal-50 p-8 sm:p-12">
          <h4 className="text-2xl font-bold text-gray-900 mb-6 text-center flex items-center justify-center">
            <i className="ri-star-line text-teal-600 mr-2"></i>
            {t("instructor_dream_title")}
          </h4>
          <p className="text-gray-700 text-lg leading-relaxed text-justify max-w-4xl mx-auto">
            {t("instructor_dream")}
          </p>
        </div>
      </div>
    </section>
  );
}
